import React from "react";
import { Route } from "react-router-dom";

/*
 * example:
 *
 * const WrapComponent = keepComponent(config)
 *
 * export default function() {
 *    return (
 *      <Switch>
 *         <Route path={`${match.path}/a`} component={WrapComponent} />
 *      </Switch>
 *    )
 * }
 *
 * */

/**
 * 缓存父级路由组件
 * @param config
 * componentA,componentB
 * 在 componentDidUpdate 函数里执行刷新操作
   componentDidUpdate() {
		if(this.props.match.isExact) {
			// 刷新操作
		}
	}
 *
 const config = {
	component: componentA,
	children: [
		{
			path: 'b',
			component: componentB,
			children: [
				{
					path: 'd',
					component: componentD
				}
			]
		},
		{
			path: 'c',
			component: componentC
		}
	]
}
 */

function iteratorRange(start, end, cb) {
  let current = start.nextSibling;
  while (current !== end) {
    cb && cb(current);
    current = current.nextSibling;
  }
}

class WrapRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onceShow: props.match.isExact
    };
    this.start = React.createRef();
    this.end = React.createRef();
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.onceShow && nextProps.match.isExact) {
      return {
        onceShow: true
      };
    }
    return null;
  }
  componentDidUpdate() {
    this.toggole();
  }

  toggole() {
    const isExact = this.props.match.isExact;
    iteratorRange(this.start.current, this.end.current, item => {
      if (item.nodeType === 1) {
        if (!isExact) {
          if (item.style.display && item.style.display !== "none") {
            item._oldStyleDisplay = item.style.display;
          }
          item.style.display = "none";
        } else if (item._oldStyleDisplay) {
          item.style.display = item._oldStyleDisplay;
        } else {
          item.style.removeProperty("display");
        }
      }
    });
  }

  render() {
    const { component: C, ...props } = this.props;
    return (
      <React.Fragment>
        <div
          keep-component="start"
          style={{ display: "none" }}
          ref={this.start}
        />
        {this.state.onceShow && <C {...props} />}
        <div keep-component="end" style={{ display: "none" }} ref={this.end} />
      </React.Fragment>
    );
  }
}

export default function keepComponent(config) {
  const { component, children } = config;
  const isChildren = children && children.length;
  if (isChildren) {
    return function(props) {
      const match = props.match;

      return (
        <React.Fragment>
          <WrapRange component={component} {...props} />
          {children.map((v, i) => (
            <Route
              strict
              path={`${match.path}/${v.path}`}
              component={keepComponent(v)}
              key={i.toString()}
            />
          ))}
        </React.Fragment>
      );
    };
  }
  return component;
}



// WEBPACK FOOTER //
// ./src/utils/router-keep-component.js